import Service, { getCallApiFunction } from '../service'

type ParamsType = {
  memberInfoId: string
}

export type VipShopType = {
  merchantId: number
  storeName: string
  headshotUrl: string
  memberInfoId: string
  refCode: string
  contactPerson: string
  contactNumber: string
  phone: string
  email: string
  totalProduct: number
  intro: string
  instagramUrl: string
  facebookUrl: string
  websiteUrl: string
}

class FetchMemberVipsApi extends Service {
  constructor({ memberInfoId }: ParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/vip/member',
      method: 'GET',
      params: {
        memberInfoId,
      },
    }
  }
}

export const fetchMemberVips = async (params: ParamsType): Promise<VipShopType[] | null> => getCallApiFunction(new FetchMemberVipsApi(params))
